const Follow = {
    STUDENT_NAME :'studentName',
    STUDENT_SURNAME : 'studentSurname',
    CREATED_AT : 'createdAt',
    STUDENT_ID : 'studentID',
}

export default Follow;